import styled from 'styled-components'

export const PageFooterStyle = styled.div`
  background: yellow;
`
